import { Engine1Proxy } from 'com-gyf-webcore-servicehub';
import GlobalHelper from '../Helpers/GlobalHelper';
let EstadoManager = function () {

    /**
     * 
     * @param {any} localValues
     * @param {any} id
     * @param {any} feature
     * @param {any} dataSource
     * @param {any} viewCallback
     */
    function _cambiarEstado(localValues, id, feature, dataSource, viewCallback) {
        let isQuery = false;
        let deleteInstance = false;
        Engine1Proxy.AddEventSourcingDataRequest(localValues, dataSource, 'Tarjetas', feature, null, isQuery, null, deleteInstance, id);
        Engine1Proxy.Execute(viewCallback, null, null, feature);
    }

    /**
     * 
     * @param {any} novedades
     * @param {any} novedadSession
     * @param {any} estadoId
     * @param {any} viewCallback
     */
    function _cambiarEstadosNovedad(novedades, novedadSession, estadoId, viewCallback) {
        novedades.forEach((novedad, index) => {
            let localValues = _mapearNovedad(estadoId, novedadSession, novedad);
            let isQuery = false;//ver
            let deleteInstance = false;//ver

            Engine1Proxy.AddEventSourcingDataRequest(localValues, "EVENTSOURCING_TRANSACTION_NOVEDAD", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, novedad.Id);
        });

        Engine1Proxy.Execute(viewCallback, null, null, "ADMINEMPCUETAR");
    }

    /**
     * 
     * @param {any} estadoId
     * @param {any} novedadSession
     * @param {any} novedad
     */
    function _mapearNovedad(estadoId, novedadSession, novedad) {
        let _nows = new Date();
        let localValues = {
            "NOVEDAD_ESTADO_ID": estadoId,
            "NOVEDAD_CAMPO_CODIGO": novedad.NovedadCampoCodigo,
            "USUARIO_LOGIN_CONFIRMACION": novedadSession.UsuarioLogin,
            "FECHA_HORA_CONFIRMACION": _nows,
            "TERMINAL_CONFIRMACION": novedadSession.Terminal
        }

        return localValues;
    }

    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} viewCallback
     */
    function _cambiarEstadoNovedad(novedad, estadoId, viewCallback) {
        let _now = new Date();
        let localValues = {
            "NOVEDAD_ESTADO_ID": estadoId,
            "NOVEDAD_CAMPO_CODIGO": novedad.Codigo,
            "USUARIO_LOGIN_CONFIRMACION": novedad.UsuarioLogin,
            "FECHA_HORA_CONFIRMACION": _now,
            "TERMINAL_CONFIRMACION": novedad.Terminal
        };
        _cambiarEstado(localValues, novedad.Id, 'ADMINEMPCUETAR', 'EVENTSOURCING_TRANSACTION_NOVEDAD', viewCallback);
    }

    /**
     * 
     * @param {any} idSolicitud
     * @param {any} executionContext
     * @param {any} estadoId
     * @param {any} viewCallback
     */
    function _cambiarEstadoSolicitud(idSolicitud, executionContext, estadoId, viewCallback) {
        let now = GlobalHelper.DateBD();
        let localValues
        if(estadoId!=3 && estadoId!=4){
            localValues = {
                "SOLICITUD_ESTADO_ID": estadoId,
                "FECHA_ESTADO": now,
                "FECHA_ULTIMA_MODIFICACION": now,
                "LOGIN_CONFIRMACION":null,
                "FECHA_CONFIRMACION":null
            };
        }else{
            localValues = {
                "SOLICITUD_ESTADO_ID": estadoId,
                "FECHA_ESTADO": now,
                "FECHA_ULTIMA_MODIFICACION": now,
                "LOGIN_CONFIRMACION":executionContext.login,
                "FECHA_CONFIRMACION":now
            };

        }
        _cambiarEstado(localValues, idSolicitud, 'SOLICITUD', 'EVENTSOURCING_TRANSACTION_SOLICITUD_FE', viewCallback);
    }

    return {
        CambiarEstadoNovedad: function (novedad, estadoId, viewCallback) {
            return _cambiarEstadoNovedad(novedad, estadoId, viewCallback);
        },
        CambiarEstadosNovedad: function (novedades, novedadSession, estadoId, viewCallback) {
            return _cambiarEstadosNovedad(novedades, novedadSession, estadoId, viewCallback);
        },
        CambiarEstadoSolicitud: function (idSolicitud, executionContext, estadoId, viewCallback) {
            return _cambiarEstadoSolicitud(idSolicitud, executionContext, estadoId, viewCallback);
        },
    }
};
let estadoManager = new EstadoManager();

module.exports = estadoManager;


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Common/Managers/EstadoManager.js